"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const components_1 = require("../../../components");
const scale_1 = require("../../../utils/scale");
const Loading = () => {
    return (react_1.default.createElement(components_1.LoadingView, { style: styles.loading }));
};
exports.default = Loading;
const styles = react_native_1.StyleSheet.create({
    loading: {
        backgroundColor: 'transparent',
        paddingVertical: (0, scale_1.scale)(12)
    }
});
